import React from "react"
import { postJson } from "../../helpers/http"
import { API_ENDPOINTS } from "../../helpers/api"
import SaveResourceModal from "./SaveResourceModal"

const SaveWheelModal = ({ slices, winner, prompt, onClose }) => {
  const handleSave = async (name) => {
    const { error } = await postJson(API_ENDPOINTS.WHEELS, {
      wheel: { name, slices, winner, prompt },
    })
    return error
  }

  return <SaveResourceModal title="Save to Account" defaultPrefix="Wheel" onSave={handleSave} onClose={onClose} />
}

export default SaveWheelModal
